import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { SendInwardByEmail } from './SendInwardByEmail'
import { SendInwardBySMS } from './SendInwardBySMS'
import {SendGridWebHookViewer} from "../../../components/SendGridWebHookViwer/SendGridWebHookViewer";

export const InwardCommunication = ({ ticket, children }) => {
  return (

      <ReactBootstrap.Dropdown style={{display:"inline"}} size="sm">

        <ReactBootstrap.Dropdown.Toggle size="sm" block variant="dark">
          Send Inward Details
        </ReactBootstrap.Dropdown.Toggle>

        <ReactBootstrap.Dropdown.Menu>
          <SendInwardByEmail ticket={ticket} />
          <SendInwardBySMS ticket={ticket} />
        </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>

  )
}
